export default {
    API_BASE: 'http://websitebe.6e-group.com/api/frontend/',
    UPLOAD_BASE: 'http://websitebe.6e-group.com/api/',
    CDN_BASE: 'http://www.6e-group.com/assets/'
}
